var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* eslint-disable react/require-default-props */
import React from 'react';
import { node, string } from 'prop-types';
import styled from 'styled-components';
var SharpCardText = styled.p(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  line-height: 30px;\n  margin: 0;\n  padding-left: 1rem;\n  padding-right: 1rem;\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.size;
});
SharpCardText.displayName = 'Card.Text';

var CardText = function CardText(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$fontColor = _ref.fontColor,
      fontColor = _ref$fontColor === void 0 ? '#42484d' : _ref$fontColor,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? '16px' : _ref$fontSize;
  return /*#__PURE__*/React.createElement(SharpCardText, {
    key: children,
    className: "scl-card-text ".concat(className),
    color: fontColor,
    "data-test-id": "scl-card-text",
    size: fontSize
  }, children);
};

CardText.propTypes = {
  /**
   Optional className to include in rendered component
  */
  className: string,

  /**
   Required and consists of everything between opening and closing tags of <Card.Text>
  */
  children: node,

  /**
   Optional to control color of text
  */
  fontColor: string,

  /**
   Optional to control size of text
  */
  fontSize: string
};
export default CardText;